// eslint-disable-next-line no-unused-vars, import/no-extraneous-dependencies
import babelpolyfill from 'babel-polyfill';
// import Vuex from 'vuex';

// eslint-disable-next-line no-unused-vars
// import NProgress from 'nprogress';

// eslint-disable-next-line import/no-unresolved
// import 'nprogress/nprogress.css';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// eslint-disable-next-line import/extensions
import '@/plugins/element';
import '@/plugins/axios';
import '@/plugins/moment';

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  const user = store.getters.getUser || {};
  const id = user.id || '';
  const authMeta = (to.meta || {}).auth;
  const auth = (authMeta === null || typeof (authMeta) === 'undefined') ? true : Boolean(authMeta);
  if (id === '' && auth) {
    next({ path: '/bigdata/login' });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
